import React, {Fragment, useEffect, useState} from "react";
import {PlaySquareOutlined, UploadOutlined, SwitcherOutlined, DeleteOutlined} from "@ant-design/icons"
import {Alert, Button, Card, Divider, Form, InputNumber, Switch, Upload} from "antd";
import { Carousel } from 'react-responsive-carousel';
import { t } from "@lingui/core/macro";


export default {
        Renderer: (props) => {
            const data=props.data

            const [loaded,setLoaded]=useState(false)
            useEffect(()=>{
                setLoaded(true)
            },[])

            if(!loaded || ! data.items){
                return null
            }

            return(
                <div style={{width:"100%",height:"inherit"}}>
                    <Carousel
                        autoPlay
                        interval={data.interval || 3000}
                        showThumbs={false}
                        statusFormatter={(currentItem, total)=>t`${currentItem} sur ${total}`}
                    >
                        {data.items.map(item=>{
                            return(
                                <div>
                                    <img src={item.image} style={{maxHeight:data.maxImageHeight?data.maxImageHeight:"inherit",objectFit:"contain"}} />
                                </div>
                            )
                        })}
                    </Carousel>
                </div>
            )

        },
        id: 'carousel-image',
        title: 'Carrousel',
        description: "Ajouter un Carrousel d'images",
        icon: <SwitcherOutlined />,
        version: 1,
}




